<!-- 页面头部 -->
<template>
  <div class="app-header" :class="{'transparent-header': isTransparentHead}">
    <div class="app-header-wrap">
      <div class="github right">
        <icon name="github" class="github-icon"></icon>
      </div>
      <router-link :to="{ name: 'index'}" class="app-logo left">
        <img src="../img/LOGO.png" alt="NS4 Gear">
        <span class="app-name">NS4 Gear</span>
      </router-link>
      <ul class="left">
        <li>
          <router-link class="cur" :to="{ name: 'index'}" exact>首页</router-link>
        </li>

        <li>
          <router-link :to="{ name: ''}" exact>NS框架</router-link>
        </li>

        <li class="more">
          <router-link :to="{ name: ''}">组件服务</router-link>
        </li>

        <li class="more">
          <router-link :to="{ name: ''}">下载</router-link>
        </li>

        <li class="more">
          <router-link :to="{ name: ''}">文档</router-link>
        </li>

        <li class="more">
          <router-link :to="{ name: ''}">联系我们</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppHeader',
  computed: {
    isTransparentHead () {
      return this.$route.name === 'index'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/variables.scss';

$logo-size: 32px;
$header-height: 60px;
.app-header{
  height: $header-height;
  padding: 0 30px;
  background-color: $dark-color;
  line-height: $header-height;
  .app-header-wrap{
    max-width: 960px;
    height: 100%;
    margin: 0 auto;
    line-height: 60px;
    font-size: 14px;
    color: #fff;
    ul, li{
      list-style: none;
    }
    .app-logo{
      position: relative;
      padding-left: 40px;
      margin-right: 50px;
      img{
        position: absolute;
        top: ($header-height - $logo-size) / 2;
        left: 0;
        width: $logo-size;
        height: $logo-size;
      }
      .app-name{
        color: #FFF;
        font-size: 18px;
        font-weight: bold;
        vertical-align: baseline;
      }
    }
    a{
      line-height: $header-height;
    }
    ul{
      padding-right: 52px;
      >li{
        float: left;
        >a{
          display: block;
          position: relative;
          padding: 0 12px;
          color: #fff;
          vertical-align: middle;
          &:after{
            content: '';
            position: absolute;
            height: 2px;
            left: 12px;
            right: 12px;
            bottom: 16px;
            background-color: #fff;
            opacity: 0;
            transition: opacity .5s ease;
          }
          &.cur:after{
            opacity: 1;
          }
        }
      }
    }
    .github{
      height: $header-height;
      line-height: $header-height;
      .github-icon{
        font-size: 20px;
        vertical-align: middle;
      }
    }
  }
}
.transparent-header{
  background-color: rgba(0, 0, 0, .3);
}
</style>



// WEBPACK FOOTER //
// src/pages/ocean/components/AppHeader.vue